import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise/styles/ag-theme-alpine.css";
import "ag-grid-enterprise/styles/ag-grid.css";
import './App.css';
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import PrimaryNavBhilosa from "app/shared/PrimaryNavBhilosa";
import { API_ENDPOINT_UNIQUE_VENDOR, API_ENDPOINT_VENDOR_SUMMARY } from "../vendorfollowup.constants";

const VendorSummary = () => {

  function renderEInvoice(params) {
    if (category === "Manual-Exempted") {
      return (
        <span className="eligiblestatus">
          <span className="dot orange"></span> Exempted
        </span>
      );
    }
    if (params.value === 'Eligible') {
      return (
        <span className="eligiblestatus">
          <span className="dot green"></span> Eligible
        </span>
      );
    } else if (params.value === 'Not Eligible') {
      return (
        <span className="eligiblestatus">
          <span className="dot red"></span> Not Eligible
        </span>
      );
    } else if (params.value === 'Exempted') {
      return (
        <span className="eligiblestatus">
          <span className="dot orange"></span> Exempted
        </span>
      );
    }
    return null; // Default case when value is not one of the above
  }

  const [searchParams] = useSearchParams();
  const category = searchParams.get("category");
  console.log(category,"category")
  const fetchUniqueVendorNames = async () => {
    const currentWorkspace = localStorage.getItem('currentWorkspace');
    const collection = "vendor_tally";
    try {
      const response = await fetch(API_ENDPOINT_UNIQUE_VENDOR, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          collection: collection, // Replace with actual collection name
          db: "gstservice", // Replace if needed
          currentWorkspace: currentWorkspace, // Replace with dynamic workspace
        }),
      });

      const data = await response.json();
      console.log(data, "unquie vendor name")
      if (data.success) {

        return data.data || [];


      } else {
        console.error("Failed to fetch vendor names:", data.message);
        return [];
      }
    } catch (error) {
      console.error("Error fetching vendor names:", error);
      return [];
    }
  };
  const columns = [
    {
      headerName: "Vendor", field: "vendor_data.enablement_gov.tradeName", filter: "agSetColumnFilter",
      floatingFilter: true,
      filterParams: {
        values: async (params) => {
          console.log("Fetching vendor names for filter...");
          try {
            const vendorNames = await fetchUniqueVendorNames();
            console.log("Fetched Vendor Names:", vendorNames);
            params.success(vendorNames);
          } catch (error) {
            console.error("Error fetching vendor names:", error);
            params.success([]);
          }
        }
      }
    },
    { headerName: "GSTIN", field: "vendor_data.vendor_gstin" },
    { headerName: "Eligibility status", field: "einvoiceEligibility", cellRenderer: renderEInvoice }


  ];
  const navigate = useNavigate()



  const currentWorkspace = localStorage.getItem('currentWorkspace');


  const getServerSideDatasource = (category) => {
    return {
      getRows: async (gridParams) => {
        console.log("Params:", gridParams);
        console.log("Grid request:", gridParams.request);
        try {
          ;
          const requestBody = {
            ...gridParams.request,
            database: "gstservice",
            table: "vendor_tally",
            workspaceid: currentWorkspace,
            filters: category ? [{ field: "einvoiceEligibility", operator: "equals", value: category }] : [],
          };
          console.log("Column Definitions:", columns);
          console.log("[Datasource] - rows requested by grid: ", gridParams.request);
          const response = await fetch(API_ENDPOINT_VENDOR_SUMMARY, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody),
          });
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const data = await response.json();
          console.log("Data fetched:", data.data.rows);

          // Assuming that the backend response returns data in the correct format



          gridParams.success({
            rowData: data.data.rows,
            rowCount: data.lastRow
          });
          // }

        } catch (error) {
          console.error("Error fetching server-side data:", error);
          gridParams.fail();
        }
      },
    };
  };

  const onGridReady = (params) => {
    const datasource = getServerSideDatasource(category);
    params.api.setGridOption("serverSideDatasource", datasource);
  };

  const goBack = () => {
    navigate(-1); // This will navigate the user back to the previous page
  };



  // Remove vendor via API




  const defaultColDef = {
    filter: true,
    floatingFilter: true,
    sortable: true,
    resizable: true,
    enableRowGroup: true,
    floatingFilter: true,
    flex: 1,
    filter: 'agTextColumnFilter',
  };

  const gridOptions = {

    animateRows: true,
    sideBar: {
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
          minWidth: 225,
          maxWidth: 225,
          width: 225,
        },
        {
          id: "filters",
          labelDefault: "Filters",
          labelKey: "filters",
          iconKey: "filter",
          toolPanel: "agFiltersToolPanel",
          minWidth: 180,
          maxWidth: 400,
          width: 250,
        },
        {
          id: "pdf viewer",
          labelDefault: "View",
          labelKey: "view",
          iconKey: "pdfIcon",
          toolPanel: "agFiltersToolPanel",
          minWidth: 180,
          maxWidth: 400,
          width: 250,
        },
      ],
      position: "right",
    },

    icons: {
      pdfIcon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10.377 11.2188L10.3828 11.1914C10.4961 10.7246 10.6387 10.1426 10.5273 9.61523C10.4531 9.19922 10.1465 9.03711 9.88477 9.02539C9.57617 9.01172 9.30078 9.1875 9.23242 9.44336C9.10352 9.91211 9.21875 10.5527 9.42969 11.3691C9.16406 12.002 8.74023 12.9219 8.42969 13.4688C7.85156 13.7676 7.07617 14.2285 6.96094 14.8105C6.9375 14.918 6.96484 15.0547 7.0293 15.1777C7.10156 15.3145 7.2168 15.4199 7.35156 15.4707C7.41016 15.4922 7.48047 15.5098 7.5625 15.5098C7.90625 15.5098 8.46289 15.2324 9.20508 13.959C9.31836 13.9219 9.43555 13.8828 9.54883 13.8438C10.0801 13.6641 10.6309 13.4766 11.1289 13.3926C11.6797 13.6875 12.3066 13.877 12.7324 13.877C13.1543 13.877 13.3203 13.627 13.3828 13.4766C13.4922 13.2129 13.4395 12.8809 13.2617 12.7031C13.0039 12.4492 12.377 12.3828 11.4004 12.5039C10.9199 12.2109 10.6055 11.8125 10.377 11.2188ZM8.23438 14.1855C7.96289 14.5801 7.75781 14.7773 7.64648 14.8633C7.77734 14.623 8.0332 14.3691 8.23438 14.1855ZM9.94531 9.58594C10.0469 9.75977 10.0332 10.2852 9.95508 10.5508C9.85938 10.1621 9.8457 9.61133 9.90234 9.54688C9.91797 9.54883 9.93164 9.56055 9.94531 9.58594ZM9.91406 11.9395C10.123 12.3008 10.3867 12.6113 10.6777 12.8418C10.2559 12.9375 9.87109 13.0957 9.52734 13.2363C9.44531 13.2695 9.36523 13.3027 9.28711 13.334C9.54688 12.8633 9.76367 12.3301 9.91406 11.9395ZM12.9531 13.2188C12.9551 13.2227 12.957 13.2285 12.9453 13.2363H12.9414L12.9375 13.2422C12.9219 13.252 12.7617 13.3457 12.0723 13.0742C12.8652 13.0371 12.9512 13.2168 12.9531 13.2188ZM16.6914 5.63672L12.4883 1.43359C12.3711 1.31641 12.2129 1.25 12.0469 1.25H3.75C3.4043 1.25 3.125 1.5293 3.125 1.875V18.125C3.125 18.4707 3.4043 18.75 3.75 18.75H16.25C16.5957 18.75 16.875 18.4707 16.875 18.125V6.08008C16.875 5.91406 16.8086 5.75391 16.6914 5.63672ZM15.4336 6.36719H11.7578V2.69141L15.4336 6.36719ZM15.4688 17.3438H4.53125V2.65625H10.4297V6.875C10.4297 7.09256 10.5161 7.30121 10.67 7.45505C10.8238 7.60889 11.0324 7.69531 11.25 7.69531H15.4688V17.3438Z" fill="black" fill-opacity="0.45"/>
          </svg>`,
    },
  };


  return (
    <div className="vendor-management" style={{display:'flex'}}>
      <div>
        <PrimaryNavBhilosa />
      </div>
      <div style={{width:'100%',marginTop:'20px'}}>
        <header className="vendor-header">
          <div className="vendor-left">
            <button className="vendor-back-btn" onClick={goBack}><svg xmlns="https://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M17.0305 10.7422L5.60281 10.7422L12.4427 16.6797C12.552 16.7754 12.4856 16.9531 12.3411 16.9531H10.6126C10.5364 16.9531 10.4641 16.9258 10.4075 16.877L3.02664 10.4727C2.95904 10.4141 2.90482 10.3416 2.86767 10.2602C2.83051 10.1789 2.81128 10.0904 2.81128 10.001C2.81128 9.91151 2.83051 9.8231 2.86767 9.74172C2.90482 9.66034 2.95904 9.58789 3.02664 9.5293L10.4505 3.08594C10.4798 3.06055 10.5149 3.04688 10.552 3.04688L12.3391 3.04687C12.4837 3.04687 12.5501 3.22656 12.4407 3.32031L5.60281 9.25781L17.0305 9.25781C17.1165 9.25781 17.1868 9.32812 17.1868 9.41406V10.5859C17.1868 10.6719 17.1165 10.7422 17.0305 10.7422Z" fill="#0A8394" />
            </svg></button>
            <h1 style={{ color: "#0A8394" }}>{category} Vendor</h1>



          </div>
          <div className="vendor-right">


          </div>
        </header>

        <div className="ag-theme-alpine" style={{ height: '90vh', width: "100%", marginTop: '20px',marginLeft:'10px',marginRight:'10px' }}>
          <AgGridReact
            // rowData={rowData}
            columnDefs={columns}
            onGridReady={onGridReady}
            rowModelType="serverSide"
            paginationPageSize={100}
            cacheBlockSize={100}

            //domLayout="autoHeight"
            defaultColDef={defaultColDef}
            gridOptions={gridOptions}
            rowGroupPanelShow="always"
            rowSelection="multiple"
            // groupDefaultExpanded={-1}

            enableSorting={true}
            enableFilter={true}
          // Remove pagination
          />
        </div>

      </div>



    </div>
  );
};

export default VendorSummary;
